<template>
  <Header_en/>
  <News_index_en></News_index_en>
  <News_page_en></News_page_en>
  <Footer_en/>
</template>

<script>
import Header_en from "@/components/EN/Header_en";
import News_index_en from "@/components/EN/news/News_index_en";
import News_page_en from "@/components/EN/news/News_page_en";
import Footer_en from "@/components/EN/Footer_en";

export default {
  name: 'News_en',
  components: {Footer_en, News_index_en, News_page_en, Header_en},
}

</script>